<template>
  <div id="integrationrule">
    <div class="header flex-between">
      <div class="header-text">
        <h1>会员积分规则设置</h1>
      </div>
      <div class="header-button">
        <el-button icon="el-icon-edit-outline" v-if="disabled" plain @click="modifyBtn"
        >修改</el-button
        >
        <el-button icon="el-icon-edit-outline" v-if="disabled" plain @click="saveBtn"
        >保存</el-button
        >
      </div>
    </div>
    <el-card shadow="never">
      <div style="width: 100%; margin: 20px">
        <el-form
            ref="formRef"
            :model="form"
            label-width="200px"
            :disabled="isDisabledForm"
        >
          <el-row>
            <el-col>
              <el-form-item label="积分生效日期">
                <el-input
                    placeholder="0"
                    v-model="form.startDay"
                    style="width: 300px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col >
              <el-form-item label="积分过期方式">
                <el-radio-group v-model="form.invalidMode">
                  <el-row>
                    <el-col>
                      <el-radio :label="0">永不过期</el-radio>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <el-form-item label="">
                        <el-radio :label="1">一年后的</el-radio>
                        <el-input
                            v-model="form.invalidMonth1"
                            :disabled="this.form.invalidMode != 1"
                            style="width: 80px; margin-left: 10px"
                        ></el-input>
                        <span style="margin-left: 10px">月</span>
                        <el-input
                            v-model="form.invalidDay1"
                            :disabled="this.form.invalidMode != 1"
                            style="width: 80px; margin-left: 10px"
                        ></el-input>
                        <span style="margin-left: 10px">日24: 00失效</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <el-form-item label="">
                        <el-radio :label="2">当年后的</el-radio>
                        <el-input
                            v-model="form.invalidMonth2"
                            :disabled="this.form.invalidMode != 2"
                            style="width: 80px; margin-left: 10px"
                        ></el-input>
                        <span style="margin-left: 10px">月</span>
                        <el-input
                            :disabled="this.form.invalidMode != 2"
                            v-model="form.invalidDay2"
                            style="width: 80px; margin-left: 10px"
                        ></el-input>
                        <span style="margin-left: 10px">日24: 00失效</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <el-form-item label="">
                        <el-radio :label="3">分期模式：当年</el-radio>
                        <div>
                          <el-input class="periodDate"
                                    value="1"
                                    :disabled="true"
                          ></el-input>
                          <span style="margin-left: 10px">月</span>
                          <el-input class="periodDate"
                                    value="1"
                                    :disabled="true"
                          ></el-input>
                          <span style="margin-left: 10px">日（含）至</span>
                          <el-input class="periodDate"
                                    v-model="form.periodMonth"  @input="checkPeriodMonth"
                                    :disabled="this.form.invalidMode != 3"
                          ></el-input>
                          <span style="margin-left: 10px">月</span>
                          <el-input class="periodDate"
                                    v-model="form.periodDay"   @input="checkPeriodDay"
                                    :disabled="this.form.invalidMode != 3"
                          ></el-input>
                          <span style="margin-left: 10px">日（不含）前获取的积分将在次年</span>
                          <el-input  class="periodDate"   @input="checkMonthDate"
                                     v-model="form.invalidMonth3"
                                     :disabled="this.form.invalidMode != 3"
                          ></el-input>
                          <span style="margin-left: 10px">月</span>
                          <el-input  class="periodDate"   @input="checkDayDate"
                                     :disabled="this.form.invalidMode != 3"
                                     v-model="form.invalidDay3"
                          ></el-input>
                          <span style="margin-left: 10px">日24: 00失效</span>
                        </div>
                        <div>
                          <el-input  class="periodDate"
                                     v-model="form.periodMonth"
                                     :disabled="true"
                          ></el-input>
                          <span style="margin-left: 10px">月</span>
                          <el-input  class="periodDate"

                                     v-model="form.periodDay"
                                     :disabled="true"
                          ></el-input>
                          <span style="margin-left: 10px">日（含）至</span>
                          <el-input  class="periodDate"
                                     value="12"
                                     :disabled="true"
                          ></el-input>
                          <span style="margin-left: 10px">月</span>
                          <el-input  class="periodDate"
                                     value="31"
                                     :disabled="true"
                          ></el-input>
                          <span style="margin-left: 10px">日（含）前获取的积分将在后年</span>
                          <el-input  class="periodDate"
                                     v-model="form.invalidMonth3"
                                     :disabled="true"
                          ></el-input>
                          <span style="margin-left: 10px">月</span>
                          <el-input  class="periodDate"
                                     :disabled="true"
                                     v-model="form.invalidDay3"
                          ></el-input>
                          <span style="margin-left: 10px">日24: 00失效</span>
                        </div>
                      </el-form-item>

                    </el-col>
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="提醒">
                <el-input
                    v-model="form.hintBeforeDay"
                    class=".el-input__inner"
                    style="width: 100px"
                    type="text"
                    onkeyup="value=value.replace(/[^\d]/g,'')"
                ></el-input>
                <span style="margin-left: 10px">天过期</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getcpyNo } from "@/utils/auth";
import { ruleQueryApi, ruleUpdateApi } from "@/api/user";
export default {
  name: "centre",
  data() {
    return {
      isDisabledForm: true,
      form: {
        invalidMode: "",
        invalidMonth1: "",
        invalidDay1: "",
        invalidMonth2: "",
        invalidDay2: "",
        invalidMonth3: "",
        invalidDay3: "",
        periodMonth: "",
        periodDay: "",
        periodMonth1: "",
        periodDay1: "",
      },
      disabled:false
    };
  },
  created() {
    this.dataList();

    let IntegrationRule = JSON.parse(localStorage.getItem("IntegrationRule"));
    if(IntegrationRule.length>0){
      this.disabled=true;
    }
  },
  methods: {
    dataList() {
      ruleQueryApi({
        cpyNO: getcpyNo(),
      }).then((res) => {
        // console.log(res);
        if (res.success) {
          res.data.invalidMonth1 = "";
          res.data.invalidMonth2 = "";
          res.data.invalidDay1 = "";
          res.data.invalidDay2 = "";
          if (res.data.invalidMode == 1) {
            res.data.invalidMonth1 = res.data.invalidMonth;
            res.data.invalidDay1 = res.data.invalidDay;
          }
          if (res.data.invalidMode == 2) {
            res.data.invalidMonth2 = res.data.invalidMonth;
            res.data.invalidDay2 = res.data.invalidDay;
          }
          if (res.data.invalidMode == 3) {
            res.data.invalidMonth3 = res.data.invalidMonth;
            res.data.invalidDay3 = res.data.invalidDay;
          }else{
            res.data.periodMonth='';
            res.data.periodDay='';
            res.data.invalidMonth3='';
            res.data.invalidDay3='';
          }
          this.form = res.data;
        }

      });
    },
    // 修改
    modifyBtn() {
      this.isDisabledForm = false;
    },
    saveBtn() {
      if (this.form.invalidMode == 1) {
        this.form.invalidMonth = this.form.invalidMonth1;
        this.form.invalidDay = this.form.invalidDay1;
      }
      if (this.form.invalidMode == 2) {
        this.form.invalidMonth = this.form.invalidMonth2;
        this.form.invalidDay = this.form.invalidDay2;
      }
      ruleUpdateApi({
        cpyNO: getcpyNo(),
        startDay: this.form.startDay,
        invalidMode: this.form.invalidMode,
        periodMonth:
            this.form.invalidMode == 3
                ? this.form.periodMonth:'',
        periodDay:
            this.form.invalidMode == 3
                ? this.form.periodDay:'',
        invalidMonth:
            this.form.invalidMode == 1
                ? this.form.invalidMonth1
                : this.form.invalidMode == 2
                    ? this.form.invalidMonth2
                    : this.form.invalidMode == 3
                        ? this.form.invalidMonth3
                        : undefined,
        invalidDay:
            this.form.invalidMode == 1
                ? this.form.invalidDay1
                : this.form.invalidMode == 2
                    ? this.form.invalidDay2
                    : this.form.invalidMode == 3
                        ? this.form.invalidDay3
                        : undefined,
        hintBeforeDay: this.form.hintBeforeDay,
      }).then((res) => {
        if (res.success !== true) return this.$message.error("修改失败!");
        this.$message.success("修改成功!");
        this.dataList();
      });
    },
    checkPeriodMonth() {
      let periodMonth=this.form.periodMonth;

      if(!this.validateNumber(periodMonth) ){
        this.form.periodMonth='';
        return this.$message.warning("请输入正确的月份");
      }
      // 确保输入是有效的数字
      if(!isNaN(periodMonth) && periodMonth>12 ){
        return this.$message.warning("请输入正确的月份");
      }
    },
    checkPeriodDay() {
      let periodDay=this.form.periodDay;

      if(!this.validateNumber(periodDay)){
        this.form.periodDay='';
        return this.$message.warning("请输入正确的日期");
      }
      // 确保输入是有效的数字
      if(!isNaN(periodDay) && periodDay>31){
        return this.$message.warning("请输入正确的日期");
      }
    },
    checkMonthDate() {
      let periodMonth=this.form.invalidMonth3;
      if(!this.validateNumber(periodMonth) ){
        this.form.invalidMonth3='';
        return this.$message.warning("请输入正确的月份");
      }
      // 确保输入是有效的数字
      if(!isNaN(periodMonth) && periodMonth>12 ){
        return this.$message.warning("请输入正确的月份");
      }
    },
    checkDayDate() {
      let periodDay=this.form.invalidDay3;
      if(!this.validateNumber(periodDay)){
        this.form.invalidDay3='';
        return this.$message.warning("请输入正确的日期");
      }
      // 确保输入是有效的数字
      if(!isNaN(periodDay) && periodDay>31){
        return this.$message.warning("请输入正确的日期");
      }
    },
    validateNumber(value) {
      return /^[1-9]\d*$/.test(value);
    }
  },
};
</script>
<style lang="scss" scoped>
#integrationrule {
  // height: 1000px;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角
/deep/input {
  height: 30px;
  border-radius: 0 !important;
}
.periodDate{
  width: 80px;
  margin-left: 10px ;
}
</style>
